// extracted by mini-css-extract-plugin
export var md = "_2r-4";
export var semantic = "_2r-5";
export var sm = "_2r-3";
export var text = "_2r-6";
export var toggleInput = "_2r-0";
export var toggleSwitch = "_2r-1";
export var xs = "_2r-2";